import React from 'react';
import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';

interface MobileCardProps {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    showArrow?: boolean;
}

export function MobileCard({
    children,
    className,
    onClick,
    showArrow = false
}: MobileCardProps) {
    const Component = onClick ? 'button' : 'div';

    return (
        <Component
            onClick={onClick}
            className={cn(
                'mobile-card w-full text-left',
                onClick && 'active:bg-accent cursor-pointer',
                className
            )}
        >
            <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">{children}</div>
                {showArrow && (
                    <ChevronRight className="h-5 w-5 text-muted-foreground flex-shrink-0 ml-2" />
                )}
            </div>
        </Component>
    );
}

interface MobileCardGroupProps {
    children: React.ReactNode;
    className?: string;
}

export function MobileCardGroup({ children, className }: MobileCardGroupProps) {
    return (
        <div
            className={cn(
                'bg-card rounded-xl overflow-hidden border border-border divide-y divide-border',
                className
            )}
        >
            {children}
        </div>
    );
}

interface MobileCardRowProps {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    showArrow?: boolean;
}

export function MobileCardRow({
    children,
    className,
    onClick,
    showArrow = false
}: MobileCardRowProps) {
    const Component = onClick ? 'button' : 'div';

    return (
        <Component
            onClick={onClick}
            className={cn(
                'w-full flex items-center justify-between p-4 min-h-[56px] text-left',
                onClick && 'active:bg-accent cursor-pointer',
                className
            )}
        >
            <div className="flex-1 min-w-0">{children}</div>
            {showArrow && (
                <ChevronRight className="h-5 w-5 text-muted-foreground flex-shrink-0 ml-2" />
            )}
        </Component>
    );
}
